<div class="assigned-agents">
  @if (title) {
    <div class="assigned-agents__header d-flex align-items-center justify-content-between gap-2">
      <span class="assigned-agents__title text-truncate">{{ title }}</span>
      @if (!loading) {
        <span class="assigned-agents__count flex-shrink-0">{{ totalCount ?? count }}</span>
      }
    </div>
  }

  @if (loading) {
    <div class="assigned-agents__state d-flex align-items-center justify-content-center">
      <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
    </div>
  } @else if (isEmpty) {
    <div class="assigned-agents__state assigned-agents__state--empty">{{ emptyMessage }}</div>
  } @else {
    <ul class="assigned-agents__list list-unstyled m-0" (scroll)="onListScroll($event)">
      @for (agent of agents; track trackByUserId($index, agent)) {
        <li class="assigned-agents__item d-flex align-items-center gap-2">
          <cx-user-avatar
            [userId]="agent.userId"
            [name]="agent.fullName"
            [size]="28"></cx-user-avatar>
          <span class="assigned-agents__name flex-grow-1 text-truncate">{{ agent.fullName }}</span>
          <span class="assigned-agents__status d-inline-flex align-items-center gap-1 flex-shrink-0">
            <span class="assigned-agents__dot rounded-circle" [ngClass]="getStatusDotClass(agent)"></span>
            <span class="assigned-agents__status-label">{{ getStatusLabel(agent) }}</span>
          </span>
        </li>
      }
      @if (loadingMore) {
        <li class="assigned-agents__more d-flex align-items-center justify-content-center">
          <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        </li>
      }
    </ul>
  }

  <div class="assigned-agents__footer"><ng-content select="[appAssignedAgentsFooter]"></ng-content></div>
</div>
